import { Component, OnInit, ViewChild } from '@angular/core';
import * as Chart from 'chart.js';
import { ResumeService } from 'src/app/modules/dashboard/services/resume.service';

// Chart.plugins.register({
//   afterDraw: function (chart) {
//     var ctx = chart.ctx;

//     chart.data.datasets.forEach(function (dataset, i) {
//       var meta = chart.getDatasetMeta(i);
//       if (!meta.hidden) {
//         meta.data.forEach(function (element, index) {
//           var { x, y, base, width, backgroundColor } = element._model;
//           var halfWidth = width / 2;
//           var left = x - halfWidth;
//           var right = x + halfWidth;
//           var top = y;
//           var bottom = base;
//           var radius = 15;

//           if (bottom - top < radius * 2) {
//             radius = (bottom - top) / 2;
//           }

//           // Clear previous bar
//           ctx.clearRect(
//             left - 1,
//             top - radius - 1,
//             right - left + 2,
//             bottom - top + radius + 2
//           );

//           ctx.beginPath();
//           ctx.fillStyle = backgroundColor;
//           ctx.moveTo(left, bottom);
//           ctx.lineTo(left, top + radius);
//           ctx.quadraticCurveTo(left, top, left + radius, top);
//           ctx.lineTo(right - radius, top);
//           ctx.quadraticCurveTo(right, top, right, top + radius);
//           ctx.lineTo(right, bottom);
//           ctx.lineTo(left, bottom); // Ensure the path is fully closed
//           ctx.fill();
//           ctx.closePath();
//         });
//       }
//     });
//   },
// });

// // Disable hover effects on bars
// Chart.defaults.global.hover.mode = null;

@Component({
  selector: 'bar-new-closed',
  templateUrl: './bar-new-closed.component.html',
  styleUrls: ['./bar-new-closed.component.scss'],
})
export class BarNewClosedComponent implements OnInit {
  constructor(private readonly resumeService: ResumeService) {}
  selected: string = 'Diario';
  @ViewChild('contentLine') contentLine;
  @ViewChild('bar') barr;
  ngOnInit() {
    // this.registerChartPlugin();

    this.getDay();
  }
  day;
  week;
  year;

  async getData() {
    return new Promise((resolve, reject) => {
      this.resumeService.getDataAlertCreatedClosed().subscribe(
        (res: any) => {
          this.day = res.day;
          this.week = res.week;
          this.year = res.year;

          resolve();
        },
        (error) => reject(error)
      );
    });
  }
  registerChartPlugin() {
    Chart.plugins.register({
      afterDraw: function (chart) {
        var ctx = chart.ctx;

        chart.data.datasets.forEach(function (dataset, i) {
          var meta = chart.getDatasetMeta(i);
          if (!meta.hidden) {
            meta.data.forEach(function (element: any, index) {
              var { x, y, base, width, backgroundColor } = element._model;
              var halfWidth = width / 2;
              var left = x - halfWidth;
              var right = x + halfWidth;
              var top = y;
              var bottom = base;
              var radius = 15;

              if (bottom - top < radius * 2) {
                radius = (bottom - top) / 2;
              }

              // Clear previous bar
              ctx.clearRect(
                left - 1,
                top - radius - 1,
                right - left + 2,
                bottom - top + radius + 2
              );

              ctx.beginPath();
              ctx.fillStyle = backgroundColor;
              ctx.moveTo(left, bottom);
              ctx.lineTo(left, top + radius);
              ctx.quadraticCurveTo(left, top, left + radius, top);
              ctx.lineTo(right - radius, top);
              ctx.quadraticCurveTo(right, top, right, top + radius);
              ctx.lineTo(right, bottom);
              ctx.lineTo(left, bottom); // Ensure the path is fully closed
              ctx.fill();
              ctx.closePath();
            });
          }
        });
      },
    });

    // Disable hover effects on bars
    Chart.defaults.global.hover.mode = null;
  }
  async getDay() {
    await this.getData();
    this.barsData(this.day);
  }

  async getWeek() {
    await this.getData();
    this.barsData(this.week);
  }

  async getYear() {
    await this.getData();
    this.barsData(this.year);
  }

  bar: Chart;

  barsData(data: any) {
    if (this.bar) {
      this.bar.destroy();
    }
    // var canvas = document.getElementById('bar') as HTMLCanvasElement;
    // var parent = document.getElementById('contentLine');

    this.barr.nativeElement.width = this.contentLine.nativeElement.offsetWidth;

    this.bar = new Chart('bar', {
      type: 'bar',
      data: {
        labels: data.label,
        datasets: [
          {
            label: 'Creados',
            data: data.initial,
            borderColor: '#00A2FF',
            borderWidth: 1,
            lineTension: 0,
            fill: false,
          },
          {
            label: 'Finalizados',
            data: data.toFinalize,
            borderWidth: 1,
            borderColor: '#69C04B',
            fill: false,
            lineTension: 0,
          },
        ],
      },
      options: {
        elements: {},
        responsive: true,
        plugins: {
          legend: {
            position: 'right',
          },
          title: {
            display: true,
            text: 'Chart.js Horizontal Bar Chart',
          },
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false, // Remove vertical grid lines
              },
            },
          ],
          yAxes: [
            {
              gridLines: {
                drawBorder: false, // Remove horizontal grid border
                display: true, // Keep horizontal lines
              },
              ticks: {
                beginAtZero: true,
                min: 0, // Y axis always starts at 0
                precision: 0, // Integer ticks only (ignored if stepSize is set)
              },
            },
          ],
        },
        tooltips: {
          enabled: false,
          custom: function (tooltipModel) {
            var tooltipEl = document.getElementById('chartjs-tooltip');
            if (!tooltipEl) {
              tooltipEl = document.createElement('div');
              tooltipEl.id = 'chartjs-tooltip';
              tooltipEl.className = 'chartjs-tooltip'; // Ensure class is added
              tooltipEl.innerHTML = '<table></table>';
              document.body.appendChild(tooltipEl);
            }

            if (tooltipModel.opacity === 0) {
              tooltipEl.style.opacity = '0';
              return;
            }

            tooltipEl.classList.remove('above', 'below', 'no-transform');
            if (tooltipModel.yAlign) {
              tooltipEl.classList.add(tooltipModel.yAlign);
            } else {
              tooltipEl.classList.add('no-transform');
            }

            function getBody(bodyItem) {
              return bodyItem.lines;
            }

            if (tooltipModel.body) {
              var titleLines = tooltipModel.title || [];
              var bodyLines = tooltipModel.body.map(getBody);

              var innerHtml = '<thead>';
              titleLines.forEach(function (title) {
                innerHtml += '<tr><th>' + title + '</th></tr>';
              });
              innerHtml += '</thead><tbody>';

              bodyLines.forEach(function (body, i) {
                var colors = tooltipModel.labelColors[i];
                var style = 'background:' + colors.backgroundColor;
                style += '; border-color:' + colors.borderColor;
                style += '; border-width: 2px';
                var span = '<span style="' + style + '"></span>';
                innerHtml += '<tr><td>' + span + body + '</td></tr>';
              });
              innerHtml += '</tbody>';

              var tableRoot = tooltipEl.querySelector('table');
              tableRoot.innerHTML = innerHtml;
            }

            var position = this._chart.canvas.getBoundingClientRect();

            // Apply styles
            tooltipEl.style.opacity = '1';
            tooltipEl.style.position = 'absolute';
            tooltipEl.style.left =
              position.left + window.pageXOffset + tooltipModel.caretX + 'px';
            tooltipEl.style.top =
              position.top + window.pageYOffset + tooltipModel.caretY + 'px';
            tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
            tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
            tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
            tooltipEl.style.padding =
              tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
            tooltipEl.style.pointerEvents = 'none';
            tooltipEl.style.zIndex = '9999'; // Ensure tooltip is on top

            // Inline style fallback for visibility
            tooltipEl.style.background = 'rgba(0, 0, 0, 0.7)';
            tooltipEl.style.borderRadius = '3px';
            tooltipEl.style.color = 'white';
            tooltipEl.style.padding = '10px';
          },
        },
      },
    });
  }
}
